import useRequest from '@space-shell/common/hooks/useRequest'
import { Context } from '@space-shell/common/services/notificationCenter'
import {
  NotificationsEndpoints,
  NotificationsService
} from '@space-shell/common/services/notificationCenter'

export const useProductsNotificationCount = () => {
  return useRequest([NotificationsEndpoints.count(), Context.PRODUCTS], () =>
    NotificationsService.getCount({ context: Context.PRODUCTS })
  )
}
